import axios from 'axios';
import qs from 'qs';
import _ from 'lodash';
import { addClass } from '../utils';

axios.interceptors.request.use((request) => {
  if (request.method === 'get') {
    request.params = _.assign(request.params, { _: _.now() });
  }
  return request;
});
axios.defaults.headers.common['Accept-Language'] = 'ko-KR';

const trimOrPass = row => (row && typeof row === 'string' ? _.trim(row) : row);

const get = (url, data, config) => {
  const params = _.pickBy(_.mapValues(_.omit(data, 'files'), trimOrPass));
  return axios.get(url, _.assign(config, { params }));
};

const del = (url, data, config) => {
  const params = _.pickBy(_.mapValues(_.omit(data, 'files'), trimOrPass));
  return axios.delete(url, _.assign(config, { params }));
};

const put = (url, data, config) => {
  let nData = '';
  if (typeof data === 'string') nData = data;
  else {
    const params = _.pickBy(_.mapValues(_.omit(data, 'files'), trimOrPass));
    nData = qs.stringify(params);
  }
  return axios.put(url, nData, config);
};

const $post = (url, params, config) => {
  const nData = qs.stringify(params, { indices: false });
  return axios.post(url, nData, config);
};

const $multipart = (url, params, config) => {
  _.assign(config, { headers: { 'content-type': 'multipart/form-data' } });
  const formData = new FormData();
  _.forEach(params, (item, key) => {
    if (`${item}` === 'FILE_INPUT_MODEL') {
      _.forEach(item.add, (file) => {
        formData.append(key, file);
      });
      _.forEach(item.remove, (remove) => {
        formData.append('removeFiles', remove);
      });
      _.forEach(item.exist, (exist) => {
        formData.append('existFiles', exist.sq);
      });
    } else {
      formData.append(key, item);
    }
  });
  return axios.post(url, formData, config);
};

const post = (url, data, config) => {
  if (typeof data === 'string') return axios.post(url, data, config);
  const params = _.pickBy(_.mapValues(_.omit(data, 'files'), trimOrPass));
  if (_.some(params, row => `${row}` === 'FILE_INPUT_MODEL')) return $multipart(url, params, config);
  return $post(url, params, config);
};

const multipart = (url, data, config) => {
  const params = _.pickBy(_.mapValues(_.omit(data, 'files'), trimOrPass));
  return $multipart(url, params, config);
};

const validation = (el, option) => {
  const errors = el.querySelectorAll('.error');
  if (errors.length) {
    let fn = alert;
    if (typeof option === 'function') {
      fn = option;
    } else {
      addClass(el, 'requested');
    }
    fn(errors[0].getAttribute('title') || '필수항목이 누락되었습니다');
    const input = (errors[0].tagName === 'INPUT' || errors[0].tagName === 'TEXTAREA') ? errors[0] : errors[0].querySelector('input, textarea');
    if (input) input.focus();
  }
  return errors.length === 0;
};

const fillFile = (info) => {
  _.forEach(_.groupBy(info.files, 'name'), (files, name) => {
    info[name] = { toString: () => 'FILE_INPUT_MODEL', exist: files };
  });
};


export default {
  get,
  post,
  multipart,
  put,
  delete: del,
  validation,
  fillFile,
  stringify: qs.stringify,
};
